import cn from 'classnames';

import Link from '@/components/link';

export type BreadcrumpPages = {
  name: string;
  href: string;
  current?: boolean;
}[];

type BreadcrumpProps = {
  pages: BreadcrumpPages;
};

export default function Breadcrump({ pages }: BreadcrumpProps) {
  return (
    <nav className="flex" aria-label="Breadcrumb">
      <ol className="flex items-center md:space-x-2 flex-wrap">
        {pages.map((page) => (
          <li key={page.name}>
            <div className="flex items-center">
              <Link
                href={page.href}
                className={cn(
                  `mr-1 text-sm font-medium hover:text-haiti`,
                  !page.current && `text-light-haiti`,
                  page.current && `text-haiti`,
                )}
                aria-current={page.current ? `page` : undefined}
              >
                {page.name}
              </Link>
              {!page.current && (
                <svg
                  className="flex-shrink-0 h-4 w-4 text-light-haiti"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  aria-hidden="true"
                >
                  <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
                </svg>
              )}
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
}
